import React, { useRef } from 'react';
import axios from 'axios';
import { Button, message } from 'antd';
import {API_BASE_URL} from "../config";

const FileUploader = ({ setImage }) => {
    const fileInputRef = useRef();

    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);

        try {
            const res = await axios.post(`${API_BASE_URL}/api/FileUpload/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'accept': '*/*',
                },
            });

            const url = res?.data?.url;
            if (url) {
                const filename = url?.split('/').pop();
                setImage(filename)
                message.success('Fayl yuklandi');
            } else {
                message.error("URL topilmadi");
            }
        } catch (error) {
            console.error(error);
            message.error('Yuklashda xatolik yuz berdi');
        }
    };

    return (
        <>
            <input
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                ref={fileInputRef}
                onChange={handleFileChange}
            />
            <Button type="default" size="small" onClick={handleUploadClick}>
                Upload Image
            </Button>
        </>
    );
};

export default FileUploader;
